























import { defineComponent, computed, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "LeaveCollabModal",
  components: { BaseConfirm, BaseButton },
  props: {
    isOwner: { type: Boolean, required: true },
    isAdmin: { type: Boolean },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const title = computed(() =>
      props.isAdmin ? $t("End this live") : $t("{0} Collab Live", [props.isOwner ? $t("End") : $t("Leave")])
    );

    const text = computed(() =>
      props.isAdmin ? $t("Are you sure?") : $t("What would you like to do with your live stream?")
    );

    const onEndClick = () => {
      loading.value = true;
      emit("endCollab", () => {
        loading.value = false;
      });
    };

    return { loading, title, text, onEndClick };
  },
});
